import usePropsContext from '/druid/internal/usePropsContext';

export default function useNumItems() {
  const { numItems } = usePropsContext();

  return [numItems];
}
